<template>
  <div class="role_wrapper">
    <div style="margin-bottom:20px;">
      <el-form :inline="true" ref="formSearch" :model="formSearch" class="demo-form-inline">
        <el-form-item label="账户级别">
          <el-select v-model="formSearch.userLevel" placeholder="账户级别" clearable>
            <el-option
              v-for="item in userLevelList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账户状态">
          <el-select v-model="formSearch.activeStatus" placeholder="账户状态" clearable>
            <el-option
              v-for="item in activeStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备类型">
          <el-select v-model="formSearch.driverType" placeholder="设备类型" clearable>
            <el-option
              v-for="item in driverTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-auth="'sys:user:check'">
          <el-button type="primary" @click="setting">赠金规则设置</el-button>
          <el-button @click="handleAlert">存款弹框提示语设置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table
      border
      v-loading="loading"
      :data="newListData"
      style="width: 100%"
    >
      <el-table-column label="账户级别" width="90">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ filterUserLevel(scope.row.userLevel) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="账户状态" width="90">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ filterActiveStatus(scope.row.activeStatus) }}</span>
        </template>
      </el-table-column>

      <el-table-column label="设备类型" width="90">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ filterDriverType(scope.row.driverType) }}</span>
        </template>
      </el-table-column>

      <el-table-column label="固定金额1" width="90">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.amounts[0].key}}</span>
        </template>
      </el-table-column>
      <el-table-column label="赠金1" width="90">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{convertValue(scope.row.amounts[0].key,scope.row)}}</span>
        </template>
      </el-table-column>
      <el-table-column label="固定金额2" width="90">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.amounts[1].key}}</span>
        </template>
      </el-table-column>
      <el-table-column label="赠金2" width="90">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{convertValue(scope.row.amounts[1].key,scope.row)}}</span>
        </template>
      </el-table-column>
      <el-table-column label="固定金额3" width="90">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{scope.row.amounts[2].key}}</span>
        </template>
      </el-table-column>
      <el-table-column label="赠金3" width="90">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{convertValue(scope.row.amounts[2].key,scope.row)}}</span>
        </template>
      </el-table-column>
      <el-table-column label="固定金额4" width="90">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.amounts[3].key}}</span>
        </template>
      </el-table-column>
      <el-table-column label="赠金4" width="90">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{convertValue(scope.row.amounts[3].key,scope.row)}}</span>
        </template>
      </el-table-column>
      <el-table-column label="固定金额5" width="90">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.amounts[4].key}}</span>
        </template>
      </el-table-column>
      <el-table-column label="赠金5" width="90">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ convertValue(scope.row.amounts[4].key,scope.row)}}</span>
        </template>
      </el-table-column>
      <el-table-column label="固定金额6" width="90">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.amounts[5].key}}</span>
        </template>
      </el-table-column>
      <el-table-column label="赠金6" width="90">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ convertValue(scope.row.amounts[5].key,scope.row)}}</span>
        </template>
      </el-table-column>
      <el-table-column label="提示语" width="90">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.markedWords | formatMarkedWords}}</span>
        </template>
      </el-table-column>
      <el-table-column label="更新人" width="90">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.updateUser}}</span>
        </template>
      </el-table-column>
      <el-table-column label="最后更新时间" width="90">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{formatDate(scope.row.updateDate)}}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('common.handle')">
        <template slot-scope="scope">
          <el-button
            size="small"
            v-auth="'sys:user:edit'"
            @click="handleAmount(scope.row)"
          >{{$t("common.edit")}}
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 编辑用户弹窗 -->
    <el-dialog :visible.sync="showAmountBox">
      <el-form :model="amountForm">
        <el-form-item label="账户级别" prop="userLevel" :label-width="formLabelWidth">
          <el-input v-model="editForm.userLevel" :disabled="edit" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="账户状态" prop="activeStatus" :label-width="formLabelWidth">
          <el-input v-model="editForm.activeStatus" :disabled="edit" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="设备类型" prop="driverType" :label-width="formLabelWidth">
          <el-input v-model="editForm.driverType" :disabled="edit" auto-complete="off"></el-input>
        </el-form-item>

        <div class="border2">
          <ul >
            <li>固定金额1</li>
            <li><el-input v-model="amountForm.amounts[0].key" @change="amountChanged(amountForm.amounts[0])" auto-complete="off"></el-input> 美元</li>
            <li><el-radio v-model="editRadio" label="0">默认</el-radio></li>
            <li>赠金1：<span style="color: red">{{amountForm.amounts[0].value}}</span></li>
          </ul>
         <ul >
            <li>固定金额2</li>
            <li><el-input v-model="amountForm.amounts[1].key"  @change="amountChanged(amountForm.amounts[1])" auto-complete="off"></el-input> 美元</li>
            <li><el-radio v-model="editRadio" label="1">默认</el-radio></li>
            <li>赠金2：<span style="color: red">{{amountForm.amounts[1].value}}</span></li>
          </ul>
          <ul >
            <li>固定金额3</li>
            <li><el-input v-model="amountForm.amounts[2].key"  @change="amountChanged(amountForm.amounts[2])" auto-complete="off"></el-input> 美元</li>
            <li><el-radio v-model="editRadio" label="2">默认</el-radio></li>
            <li>赠金3：<span style="color: red">{{amountForm.amounts[2].value}}</span></li>
          </ul>
          <ul >
            <li>固定金额4</li>
            <li><el-input v-model="amountForm.amounts[3].key"  @change="amountChanged(amountForm.amounts[3])" auto-complete="off"></el-input> 美元</li>
            <li><el-radio v-model="editRadio" label="3">默认</el-radio></li>
            <li>赠金4：<span style="color: red">{{amountForm.amounts[3].value}}</span></li>
          </ul>
          <ul >
            <li>固定金额5</li>
            <li><el-input v-model="amountForm.amounts[4].key"  @change="amountChanged(amountForm.amounts[4])" auto-complete="off"></el-input> 美元</li>
            <li><el-radio v-model="editRadio" label="4">默认</el-radio></li>
            <li>赠金5：<span style="color: red">{{amountForm.amounts[4].value}}</span></li>
          </ul>
          <ul >
            <li>固定金额6</li>
            <li><el-input v-model="amountForm.amounts[5].key"  @change="amountChanged(amountForm.amounts[5])" auto-complete="off"></el-input> 美元</li>
            <li><el-radio v-model="editRadio" label="5">默认</el-radio></li>
            <li>赠金6：<span style="color: red">{{amountForm.amounts[5].value}}</span></li>
          </ul>
        </div>
        <el-form-item label="提示语" prop="markedWords" :label-width="formLabelWidth">
          <el-input type="textarea" v-model="amountForm.markedWords" auto-complete="off"></el-input>
          <label>
            超链接插入示例：<br>
            超过$500,&lt;a href=&quot;<label style="color: red">在线客服的链接地址</label>&quot;  class=&quot;ui-link&quot;&gt;
            <label style="color: red">联系客服</label>&lt;/a&gt;领取现金红包
          </label>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showAmountBox = false">{{$t("common.cancle")}}</el-button>
        <el-button type="primary" @click="changeAmount">{{$t("common.ok")}}</el-button>
      </div>
    </el-dialog>

    <!-- 编辑用户弹窗 -->
    <el-dialog :visible.sync="showAlertBox">
      <el-form :model="editAlertForm">
        <el-form-item label="激活用户" prop="actived" :label-width="formLabelWidth">
          <el-input type="textarea" v-model="editAlertForm.actived" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="未激活用户" prop="noActived" :label-width="formLabelWidth">
          <el-input type="textarea" v-model="editAlertForm.noActived" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showAlertBox = false">{{$t("common.cancle")}}</el-button>
        <el-button type="primary" @click="changeAlert">{{$t("common.ok")}}</el-button>
      </div>
    </el-dialog>

    <!-- 赠金设置 -->
    <settingUpdate v-show="addOrUpdateVisible" @refreshDataList="getUserList" ref="settingUpdate"></settingUpdate>
  </div>
</template>

<script>
    import {localRead} from "@/utils/tools";
    import {MessageBox, Message} from "element-ui";
    import DateUtil from '@/utils/IM/tradeDataUtil.js';
    import Qs from 'qs';
    import URL from '@/views/newmis36/util/url';
    import settingUpdate from '@/views/newmis36/tracker/settingUpdate.vue'

    export default {
        components: {
            settingUpdate
        },
        data() {
            return {
                userLevelList: [
                    {
                        value: 'MIN',
                        label: "迷你"
                    },
                    {
                        value: 'STD',
                        label: "标准"
                    },
                    {
                        value: 'PLA',
                        label: "铂金"
                    }
                ],
                activeStatusList: [
                    {
                        value: '0',
                        label: "未激活"
                    },
                    {
                        value: '1',
                        label: "已激活"
                    }
                ],
                driverTypeList: [
                    {
                        value: '0',
                        label: "移动端"
                    },
                    {
                        value: '1',
                        label: "PC端"
                    }
                ],
                listData: [],
                active:{},
                ruleList: {},
                formSearch: {
                    userLevel: "",
                    activeStatus: "",
                    driverType: ""
                },
                loading: true,
                showAmountBox: false,
                showAlertBox:false,
                formLabelWidth: "150px",
                addOrUpdateVisible:false,
                edit: true,
                editRadio:"1",
                amountForm: {
                    userLevel: "",
                    activeStatus: "",
                    driverType: "",
                    amounts: [
                        {value: 0, key: 0},
                        {value: 0, key: 0},
                        {value: 0, key: 0},
                        {value: 0, key: 0},
                        {value: 0, key: 0},
                        {value: 0, key: 0},
                    ],
                    markedWords:""
                },
                editForm:{
                    userLevel:"",
                    activeStatus:"",
                    driverType:""
                },
                editAlertForm:{
                    actived:"",
                    noActived:"",
                }

            };
        },
        created() {
        },
        computed: {
            newListData: {
                get() {
                    if (!this.formSearch.userLevel && !this.formSearch.driverType && !this.formSearch.activeStatus) {
                        return this.listData;
                    }
                    let newList = this.listData.filter(this.doFilter);
                    return newList;
                }
            }
        },
        mounted() {
            this.getUserList();
            this.depositAlertList();
        },
        methods: {
            getUserList() {
                this.$axios.get(URL.amountSetting.list).then(res => {
                    if (res.code == 0) {
                        this.listData = res.result.list;
                        this.ruleList = res.result.rule;
                        this.loading = false;
                    }
                });
            },
            depositAlertList() {
                this.$axios.get(URL.amountSetting.depositAlertList).then(res => {
                    if (res.code == 0) {
                        this.active = res.result;
                        this.loading = false;
                    }
                });
            },
            doFilter(element, index, array) {
                if (this.formSearch.activeStatus && this.formSearch.activeStatus != element.activeStatus) {
                    return false;
                }
                if (this.formSearch.userLevel && this.formSearch.userLevel != element.userLevel) {
                    return false;
                }
                if (this.formSearch.driverType && this.formSearch.driverType != element.driverType) {
                    return false;
                }
                return true;
            },
            resetSearch() {
                this.formSearch = {};
            },
            filterUserLevel(data) {
                if (data === "MIN") {
                    return "迷你";
                } else if (data === "STD") {
                    return "标准";
                } else if (data === "PLA") {
                    return "铂金";
                }
                return "巴菲特";
            },
            filterActiveStatus(data) {
                if (data == 0) {
                    return "未激活";
                }
                return "已激活";
            },
            filterDriverType(data) {
                if (data == 0) {
                    return "移动端";
                }
                return "PC端";
            },
            formatMarkedWords(data) {
                if (!DateUtil.isEmpty(data)) {
                    if (data.length > 20) {
                        return data.substring(0, 20) + "...";
                    }
                }
                return data;
            },
            convertValue(amount, full) {
                var value = 0;
                if (this.ruleList) {
                    for (var i = 0; i < this.ruleList.aountRule.length; i++) {
                        var tmp = this.ruleList.aountRule[i];
                        if (this.ruleList.userLevel.indexOf(full.userLevel) != -1) {
                            if (tmp.activeStatus == full.activeStatus) {
                                if (amount >= tmp.gt) {
                                    value = tmp.amount;
                                }
                                if (tmp.lt) {
                                    if (amount < tmp.lt) {
                                        break;
                                    } else {
                                        value = 0;
                                    }
                                }
                            }
                        }
                    }
                }
                return value;
            },
            amountChanged(obj) {
                obj.value=this.convertValue(obj.key,this.amountForm);
            },
            formatDate(val) {
                if (val) {
                   return  DateUtil.formatDate(val, "yyyy-MM-dd hh:mm:ss");
                }
            },
            handleAmount(row) {
                this.amountForm = {
                    ...this.amountForm,
                    ...row
                };
                this.editForm.userLevel=this.filterUserLevel(this.amountForm.userLevel);
                this.editForm.activeStatus=this.filterActiveStatus(this.amountForm.activeStatus);
                this.editForm.driverType=this.filterDriverType(this.amountForm.driverType);
                this.showAmountBox = true;
                //循环初始化赠金
                 this.amountForm.amounts.forEach((value,index)=>{
                    if(value.value==1){
                       this.editRadio = String(index);
                    }
                    this.amountChanged(value);
                });
            },
            changeAmount() {
                // 验证
                if(DateUtil.isEmpty(this.amountForm.amounts[0].key)||
                    this.amountForm.amounts[0].key<=0||
                    DateUtil.isEmpty(this.amountForm.amounts[1].key)||
                    this.amountForm.amounts[1].key<=0||
                    DateUtil.isEmpty(this.amountForm.amounts[2].key)||
                    this.amountForm.amounts[2].key<=0){
                    this.$message.error("固定金额必须设置至少3个,且都大于0");
                    return;
                }
                this.amountForm.amounts.forEach((value,index)=>{
                    value.value = 0;
                    //处理默认选中
                    if(index==this.editRadio){
                        value.value = 1;
                    }
                    if(value.key==null){
                        value.key="";
                    }
                });
                this.$axios.post(URL.amountSetting.edit, Qs.stringify(this.amountForm,{arrayFormat: 'indices', allowDots: true})).then(res => {
                        if(res.code==0){
                            this.$message.success("提交成功");
                            this.getUserList();
                        }else{
                            this.$message.error("提交失败");
                        }
                }).catch(res => {
                    this.$message.error("提交失败");
                });

                this.showAmountBox = false;
            },
            handleAlert() {
                this.showAlertBox = true;
                this.editAlertForm = {
                    ...this.editAlertForm,
                    ...this.active
                };
            },
            changeAlert() {
                this.$axios.post(URL.amountSetting.editDepositAlert, this.editAlertForm || {},{ headers: { 'Content-Type': 'application/json' } }).then(res => {
                    if(res.code==0){
                        this.$message.success("提交成功");
                        this.depositAlertList();
                    }else{
                        this.$message.error("提交失败");
                    }
                }).catch(res => {
                    this.$message.error("提交失败");
                });

                this.showAlertBox = false;
            },
            setting(){
                //赠金规则设置
                this.addOrUpdateVisible = true;
                this.$nextTick(() => {
                    this.$refs.settingUpdate.init(this.ruleList);
                })
            }
        }
    };
</script>
<style lang="scss" scoped>
  .role_wrapper {
    margin: 50px;
    border: 1px solid #ebebeb;
    border-radius: 3px;
    transition: 0.2s;
    padding: 20px;
  }

  .role_wrapper:hover {
    box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6),
    0 2px 4px 0 rgba(232, 237, 250, 0.5);
  }

  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }

  .border2 {
    margin-bottom: 15px;
    ul{
      display: flex;
      align-items: center;
      margin-left: 70px;
      li{
        margin-right: 20px;
        margin-bottom: 12px;
        .el-input{
          width: 120px;
        }
      }
    }
  }
</style>
